<div class="thanks-page">
    <div class="container">
        <div class="row mt-5 pt-5 mb-5">
            <div class="col-sm-12">
                <div class="thanks-center">
                    <div class="heading-missingpets">
                        <h2>
                            {{'Sorry! You do not have access to this page.' | translate}}
                        </h2>
                    </div>
                   
                </div>
            </div>
            
        </div>
        <!-- <app-search></app-search> -->
    </div>
</div>